import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { getPatientDevices } from "@/api-RH";
import moment from "moment/moment";
import { MachineType } from "@/vue/types/machine";
import { AxiosResponse } from "axios";

export const usePatientDevicesStore = defineStore('patientDevicesStore', () => {
    const devices = ref<MachineType[]>([]);
    const isLoading = ref(false);

    const firstUsageDate = computed(() => {
        if (!devices.value) return

        const dates = devices.value.map(device => moment.utc(device.start_date));

        return moment.min(dates).format('YYYY-MM-DD');
    });

    const FetchDevices = async (patientId: number) => {
        isLoading.value = true;

        try {
            const { data } = await getPatientDevices.request(patientId) as AxiosResponse<{ data: MachineType[] }>;

            devices.value = data.data.sort((a, b) => {
                if (!a.start_date || !b.start_date) return 0;

                return new Date(b.start_date).getTime() - new Date(a.start_date).getTime();
            }).map(item => {
                item.start_date = item.start_date ? moment.utc(item.start_date).format('YYYY-MM-DD') : null;
                item.end_date = item.end_date ? moment.utc(item.end_date).format('YYYY-MM-DD') : null;
                return item;
            });
        } catch (e) {
            console.error('Error occurs, while loading patient devices data', e)
        } finally {
            isLoading.value = false;
        }
    }

    return {
        devices,
        isLoading,
        firstUsageDate,
        FetchDevices,
    };
});
